import React from 'react';

export function Skeleton({ className = '', variant = 'text' }) {
  const baseClass = 'skeleton rounded';

  const variants = {
    text: 'h-4 w-full',
    title: 'h-6 w-3/4',
    avatar: 'h-10 w-10 rounded-full',
    button: 'h-9 w-24 rounded-md',
    card: 'h-32 w-full rounded-lg',
    row: 'h-12 w-full',
  };

  return (
    <div className={`${baseClass} ${variants[variant] || ''} ${className}`} aria-hidden="true" />
  );
}

export function SkeletonCard() {
  return (
    <div className="card">
      <div className="card-body stack-md" style={{ paddingTop: 20 }}>
        <div className="row" style={{ justifyContent: 'space-between' }}>
          <Skeleton className="h-4 w-24" />
          <Skeleton className="h-8 w-8 rounded-full" />
        </div>
        <Skeleton className="h-8 w-16" />
        <Skeleton className="h-3 w-32" />
      </div>
    </div>
  );
}

export function SkeletonTable({ rows = 5 }) {
  return (
    <div className="card">
      <table className="tbl skeleton-table" aria-hidden="true">
        <thead>
          <tr>
            <th><Skeleton className="h-4 w-3/4" /></th>
            <th><Skeleton className="h-4 w-16" /></th>
            <th><Skeleton className="h-4 w-14" /></th>
            <th><Skeleton className="h-4 w-20" /></th>
            <th><Skeleton className="h-4 w-20" /></th>
          </tr>
        </thead>
        <tbody>
          {Array.from({ length: rows }).map((_, i) => (
            <tr key={i}>
              <td><Skeleton className="h-4 w-3/4" /></td>
              <td><Skeleton className="h-6 w-16 rounded-full" /></td>
              <td><Skeleton className="h-4 w-14" /></td>
              <td><Skeleton className="h-4 w-20" /></td>
              <td><Skeleton className="h-4 w-20" /></td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export function SkeletonDetail() {
  return (
    <div className="stack-xl">
      <div className="row" style={{ justifyContent: 'space-between' }}>
        <div className="col">
          <Skeleton className="h-4 w-24" />
          <Skeleton className="h-8 w-64" />
        </div>
        <div className="row">
          <Skeleton variant="button" />
          <Skeleton variant="button" />
        </div>
      </div>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, minmax(0, 1fr))', gap: 24 }}>
        <SkeletonCard />
        <SkeletonCard />
      </div>
    </div>
  );
}
